import styled from "@emotion/styled";

import {
  fontMerriweather,
  fontRoboto,
  fontRobotoCondensed,
  setFullViewportWidthStyles,
  theme,
} from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";
import { SCMPYoutubeVideo } from "scmp-app/components/scmp-youtube-video";
import { TopicLink } from "scmp-app/components/topic/topic-link";

export const Container = styled.div`
  display: grid;
  grid:
    "video-player" min-content
    "headline" min-content
    "information" min-content
    "function-bar" min-content
    / 100%;
  row-gap: 12px;

  ${theme.breakpoints.up("tablet")} {
    grid:
      "video-player video-player video-player" min-content
      "headline divider function-bar" min-content
      "information divider function-bar" min-content
      / minmax(0, 1fr) 41px 192px;
    row-gap: 16px;
  }
`;

export const StyledSCMPYoutubeVideo = styled(SCMPYoutubeVideo)`
  grid-area: video-player;

  border-radius: 12px;
  aspect-ratio: 16/9;

  overflow: hidden;

  ${theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthStyles()}
    border-radius: 0;
  }

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 8px;
  }
`;

export const Headline = styled.h2`
  grid-area: headline;

  margin: 0;

  color: #000000;
  font-weight: 400;
  font-size: 20px;
  font-family: ${fontMerriweather};
  line-height: 140%;

  ${theme.breakpoints.up("tablet")} {
    font-size: 24px;
  }

  ${theme.breakpoints.up("desktop")} {
    font-size: 28px;
  }
`;

export const HeadlineEntityLink = styled(EntityLink)`
  :hover {
    color: #2c4692;
  }
`;

export const InformationContainer = styled.div`
  grid-area: information;

  display: flex;
  flex-flow: wrap row;
  gap: 20px 16px;
  align-items: center;
`;

export const StyledTopicLink = styled(TopicLink)`
  padding: 8px;

  color: #000000;
  font-weight: 700;
  font-size: 12px;
  font-family: ${fontMerriweather};
  font-style: italic;
  line-height: normal;

  border: 1px solid #000000;

  ${theme.breakpoints.up("tablet")} {
    font-size: 14px;
  }
`;

export const SectionBreadcrumb = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  align-items: center;

  color: #000000;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRoboto};
  font-style: italic;
  line-height: normal;

  ${theme.breakpoints.up("tablet")} {
    font-size: 14px;
  }
`;

export const SectionBreadcrumbLink = styled(EntityLink)`
  color: inherit;
  font: inherit;

  &:hover {
    color: #2c4692;
  }
`;

export const StoryButtonContainer = styled.div`
  ${theme.breakpoints.down("tablet")} {
    flex-basis: 100%;
  }

  ${theme.breakpoints.only("mobile")} {
    margin-block-end: 8px;
  }
`;

export const ReadFullStory = styled(EntityLink)`
  display: inline-block;

  padding-block: 10px;
  padding-inline: 20px;

  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  text-transform: uppercase;
  text-decoration: none;

  border-radius: 4px;

  background: #2c4692;
`;

export const Divider = styled.div`
  grid-area: divider;

  display: none;

  ${theme.breakpoints.up("tablet")} {
    display: block;

    inline-size: 1px;
    margin-inline: 20px;

    background: rgba(0, 0, 0, 0.2);
  }
`;

export const FunctionBar = styled.div`
  grid-area: function-bar;

  display: flex;
  gap: 16px;
  align-items: start;
`;
